<template>
  <div class="grid grid-cols-6 gap-6">
    <div class="col-span-6 sm:col-span-3 lg:col-span-2">
      <label for="nombre" class="block text-sm font-medium text-gray-700">Nombre</label>
      <input type="text" id="nombre" :value="loadData.nombre"
             @change="(newSecretariaEjecutora)=>$emit('updateValues', {'nombre': newSecretariaEjecutora.target.value})"
             class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
    </div>
    <div class="col-span-6 sm:col-span-3 lg:col-span-2">
      <label for="id_macro_ejecutor" class="block text-sm font-medium text-gray-700"> Macro Ejecutor </label>
      <select id="id_macro_ejecutor" :value="loadData.id_macro_ejecutor"
              class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              @change="(idMacroEjecutorNew)=>$emit('updateValues', {'id_macro_ejecutor': customUpdateValueData('id_macro_ejecutor', idMacroEjecutorNew.target.value)})">
        <option value="" selected>Seleccione un macro ejecutor...</option>
        <option v-for="(macroEjecutor, index) of collectionMacroEjecutor" :key="'B'+index" :value="macroEjecutor.id">{{
            macroEjecutor.nombre
          }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SecretariasEjecutorasCrearActualizarComponent',
  props: ['loadData', 'collectionMacroEjecutor','customUpdateValueData'],
  emits: ["updateValues"],
}
</script>